export function formatNumber(num: string, decimals: number = 2) {
  if (isNaN(Number(num))) {
    return "--";
  }
  const newNum = (
    (Number(num) * Math.pow(10, decimals)) /
    Math.pow(10, decimals)
  ).toString();

  var parts = newNum.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}
